import React, { FC } from 'react'
import './pledge-slot.css'

// COMPONENTS
import PledgeCell from '../pledge-cell'

// UTILITIES
import { flatten } from '@utils/string-helper'


interface Props extends React.ComponentProps<typeof PledgeCell> {
    selected?: boolean
    loading?: boolean
}

const PledgeSlot: FC<Props> = (props) => {
    const { className: classProps, status, selected, loading, ...cellProps } = props
    const className = flatten('pledge-slot', { selected }, classProps)

    return <PledgeCell className={className} status={status} loading={loading} {...cellProps} />
}

export default PledgeSlot